import { uniqBy } from "lodash";
import {
  REQUEST_BINS_SUCCESS,
  CREATE_BIN_SUCCESS,
  RENAME_BIN_SUCCESS,
  EDIT_BINS_SUCCESS,
  MAKE_BIN_AVAILABLE_SUCCESS,
  DELETE_BIN_SUCCESS,
  CLEAR_BIN_SUCCESS,
} from "../../constants/actionTypes";
import { capsFromSizeClass } from "../../helpers/binAssignment";

const INITIAL_STATE = {
  bins: [],
  assignmentMode: "next",
  smallMaxLb: 5,
  mediumMaxLb: 20,
  error: null,
};

const sizeLimitsOf = (state = {}) => ({
  smallMaxLb: state.smallMaxLb,
  mediumMaxLb: state.mediumMaxLb,
});

const patchBinParams = (bin, params = {}, limits) => {
  const next = { ...bin };
  if (params.name != null) next.name = params.name;
  if (Object.prototype.hasOwnProperty.call(params, "maxQuantity")) {
    next.maxQuantity = params.maxQuantity;
  }
  if (Object.prototype.hasOwnProperty.call(params, "sizeClass")) {
    const sized = capsFromSizeClass(params.sizeClass, limits);
    if (sized) {
      next.sizeClass = sized.sizeClass;
      next.minWeightOz = sized.minWeightOz;
      next.maxWeightOz = sized.maxWeightOz;
    } else {
      next.sizeClass = params.sizeClass || null;
    }
  }
  if (Object.prototype.hasOwnProperty.call(params, "maxWeightOz")) {
    next.maxWeightOz = params.maxWeightOz;
  }
  if (Object.prototype.hasOwnProperty.call(params, "minWeightOz")) {
    next.minWeightOz = params.minWeightOz;
  }
  return next;
};

export default function bins(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_BINS_SUCCESS:      
      let newBins = [...(action?.payload?.bins || [])];
      newBins = uniqBy(newBins, (x) => x.id);
      newBins = newBins.map((bin) => ({
        ...bin,
        orderDetails: action?.payload?.orderDetails?.[bin?.orderId],
      }));

      return {
        ...state,
        bins: newBins,
        assignmentMode: action?.payload?.assignmentMode || state.assignmentMode,
        smallMaxLb:
          action?.payload?.smallMaxLb != null
            ? action.payload.smallMaxLb
            : state.smallMaxLb,
        mediumMaxLb:
          action?.payload?.mediumMaxLb != null
            ? action.payload.mediumMaxLb
            : state.mediumMaxLb,
        error: null,
      };

    case CREATE_BIN_SUCCESS:
      const withAddedBins = [...state.bins, ...action.payload?.createdBins];

      return {
        ...state,
        bins: uniqBy(withAddedBins, (x) => x.id),
      };

    case RENAME_BIN_SUCCESS:
      const updatedBin2 = state.bins.map((f) => {
        if (f.id === action.payload?.binId) {
          return patchBinParams(f, action.payload?.params || {}, sizeLimitsOf(state));
        }

        return f;
      });
      return {
        ...state,
        bins: updatedBin2,
      };

    case EDIT_BINS_SUCCESS: {
      const ids = new Set(action.payload?.updated || []);
      const params = action.payload?.params || {};
      return {
        ...state,
        bins: state.bins.map((f) => {
          if (!ids.has(f.id)) return f;
          return patchBinParams(f, params, sizeLimitsOf(state));
        }),
        error: null,
      };
    }

    case MAKE_BIN_AVAILABLE_SUCCESS:
      const updatedBin = state.bins.map((f) => {
        if (f.id === action.payload?.id) {
          return action.payload;
        }

        return f;
      });
      return {
        ...state,
        bins: updatedBin,
      };

    case DELETE_BIN_SUCCESS:
      const binsAfterDelete = state.bins.filter(
        (f) => f?.id !== action.payload
      );
      return {
        ...state,
        bins: binsAfterDelete,
      };
    case CLEAR_BIN_SUCCESS:
      const binsAfterClear = state.bins.map((f) => {
        if (f.id === action.payload?.id) {
          const { occupiedAt, ...rest } = f;
          return {
            ...rest,
            contents: [],
            fulfilledItems: [],
            occupied: false,
            orderId: "",
            remainingItems: [],
          };
        }

        return f;
      });
      return {
        ...state,
        bins: binsAfterClear,
      };
    default:
      return state;
  }
}
